import {qspost} from '@/plugins/axios'
import {ONLINEHOST_EMOF} from "@/config";
/*公共*/

export const allMember = (id, user_id) => qspost('/Admin/User/getUserListAll', {id, user_id})

export const getUserListAllByEmail = (id, user_id) => qspost('/admin/User/getUserListAllByEmail', {id, user_id})


export const getUserListAllFh = (id, user_id) => qspost('/Admin/User/getUserListAllFh', {id, user_id})

/*
 * 统计用户的 会员数量   待审核数量   待续费数量
 * @constructor jack
 * */
export const tongJiUserNumber = () => qspost('/Admin/tongji/tongJiUserNumber', {})

/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatistics = () => qspost('/Admin/tongji/getUserNumberStatistics', {})


/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsPersonal', {})


/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegion = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegion', {})



/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegionPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegionPersonal', {})



/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberAddress = () => qspost('/', {})


/*
 * 会员等级统计
 * @constructor jack
 * */
export const getUserGradeStatistics = () => qspost('/Admin/tongji/getUserGradeStatistics', {})

/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatistics = () => qspost('/Admin/tongji/userRenewStatistics', {})


/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatisticsPersonal = () => qspost('/Admin/tongji/userRenewStatisticsPersonal', {})



/*
 * 统计组织数据  通知公告、组织动态、活动管理、服务申请
 * @constructor jack
 * */
export const jiGouShuJu = () => qspost('/Admin/tongji/jiGouShuJu', {})








/*
 * 通知公告-列表
 * @constructor jack
 * */
export const getExamineList = (page, limit,state, keyword) => qspost('/Admin/Notice/getExamineList', {page, limit,state, keyword})
/*
 * 通知公告-列表 审核
 * @constructor jack
 * */
export const examineNoticeData = (id, stateMsg,state) => qspost('/Admin/Notice/examineNoticeData', {id, stateMsg,state})

/*/*
 * 通知公告-列表
 * @constructor jack
 * */
export const noticeList = (page, limit, keyword) => qspost('/Admin/Notice/getList', {page, limit, keyword})

/*
 * 通知公告-未读人员列表
 * @constructor jack
 * */
export const getNotReadList = (id, type) => qspost('/Admin/Notice/getNotReadList', {id, type})

/*
 * 通知公告-未读人员提醒
 * @constructor jack
 * */
export const noticeRemind = (id, user_id) => qspost('/Admin/Notice/remind', {id, user_id})


/*
 * 通知公告-详情
 * @constructor jack
 * */
export const noticeDetail = (id) => qspost('/Admin/Notice/detail', {id})

/*
 * 通知公告-反馈
 * @constructor jack
 * */
export const getNoticeFeedback = (isFeedback,searchKey,id) => qspost('/Admin/Notice/getFeedback', {isFeedback,searchKey,id})

/*
 * 通知公告-标签选择
 * @constructor jack
 * */
export const labelSelect =() => qspost('/Admin/Customlable/getOrgToUserLableAll', {})

/*
 * 通知公告-发布
 * @constructor jack
 * */
export const noticeAdd = (title,is_feedback,content,fileJson,ids,fenhuiIds,feedbackJson
) => qspost('/admin/Notice/setInfo', {title,is_feedback,content,fileJson,ids,fenhuiIds,feedbackJson})

/*
 * 通知公告-修改
 * @constructor jack
 * */
export const noticeEdit = (title,content,fileJson,ids,fenhuiIds,id
) => qspost('/Admin/Notice/setInfo', {title,content,fileJson,ids,fenhuiIds,id})

/*
 * 通知公告-删除
 * @constructor jack
 * */
export const noticeDel = (id) => qspost('/Admin/Notice/del', {id})


/*
 * 邮件发送-列表
 * */
export const getEmailList = (page,limit) => qspost('/admin/Sendemail/getEmailList', {page,limit})

/*
 * 添加、编辑邮箱
 * */
export const saveEmail = (id,email,code) => qspost('/admin/Sendemail/saveEmail', {id,email,code})

/*
 * 删除邮箱
 * */
export const delEmail = (id) => qspost('/admin/Sendemail/delEmail', {id})

/*
 * 邮件发送-列表
 * */
export const send_email_log = (page,limit) => qspost('/admin/Sendemail/send_email_log', {page,limit})

/*
 * 验证是否存在email的字段
 * */
export const checkEmailfield = () => qspost('/admin/Sendemail/checkEmailfield', {})

/*
 * 邮件发送-列表
 * */
export const sendEmail = (email,code,title,message,user) => qspost('/admin/Sendemail/sendEmail', {email,code,title,message,user})


/*
 * 短信发送-列表
 * @constructor jack
 * */
export const messageList = () => qspost('/Admin/Sendsms/send_sms_log', {})

/*
 * 短信发送-删除功能
 * @constructor jack
 * */
export const delSendSmsLog = (id) => qspost('/Admin/Sendsms/delSendSmsLog', {id})

/*
 * 短信发送-列表
 * @constructor jack
 * */
export const getSendSMSUserList = (orderId) => qspost('/Admin/Sendsms/getSendSMSUserList', {orderId})

/*
 * 短信发送-短信模版获取
 * @constructor jack
 * */
export const getSmsDemoList = () => qspost('/Admin/Sendsms/smsList', {})

/*
 * 短信发送-短信发送
 * @constructor jack
 * */
export const sendMessage = (message,template_id,user_id,delSMSNum) => qspost('/Admin/Sendsms/sendMessage',
    {message,template_id,user_id,delSMSNum})


/*
 * 获得短信的剩余条数
 * @constructor jack
 * */
export const getSMSShengYuNumber = () => qspost('/admin/Sendsms/getSMSShengYuNumber', {})


/*会员管理*/

/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersList = (page,limit,start_time,end_time,address,keyword,rank_id,status,time,is_locking,order,share_id,
                            select_fenhui_id = '',preserve_type=0) => qspost('/Admin/User/getList', {
                                page,limit,start_time,end_time,address,keyword,rank_id,status,time,is_locking,order,share_id,select_fenhui_id,preserve_type})

/*
 * 会员管理-导出
 * */
export const memberDocExport = (user_id) => qspost('/admin/exportdoc/memberDocExport', {user_id})

/*
 * 会员管理-设置排序
 * @constructor jack
 * */
export const setSort = (sort) => qspost('/Admin/User/setSort', {sort})



/*会员管理*/

/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersPersonalList = (page,limit,start_time,end_time,keyword,rank_id,status,time,is_locking,order,share_id,
                                    select_fenhui_id = '',preserve_type=0) => qspost('/Admin/Personal/getList',
    {page,limit,start_time,end_time,keyword,rank_id,status,time,is_locking,order,share_id,select_fenhui_id,preserve_type})

/*
 * 会员管理-会员锁定与解锁
 * @constructor jack
 * */
export const memberSet = (user_id,state) => qspost('/Admin/User/setState', {user_id,state})

/*
 * 会员管理-会员锁定与解锁
 * @constructor jack
 * */
export const memberSetOut = (user_id,state) => qspost('/Admin/User/setOut', {user_id,state})


/*
 * 会员管理-会员证书
 * @constructor jack
 * */
export const memberCertificate = (userId) => qspost('/Admin/User/getUserZhengShu', {userId})

/*
 * 分支机构管理-分支机构证书
 * @constructor jack
 * */
export const getFhPinShu = (id) => qspost('/Admin/User/getFhPinShu', {id})


/*
 * 会员管理-会员删除
 * @constructor jack
 * */
export const memberDel = (id) => qspost('/Admin/User/del', {id})


/*
 * 会员管理-会员添加
 * @constructor jack
 * */
export const memberAdd = (userMoreJson,end_time,user_id,userType,preserve_type = 0) => qspost('/Admin/User/setUser', {userMoreJson,end_time,user_id,userType,preserve_type})


/*
 * 会员管理-会员添加
 * @constructor jack
 * */
export const setUserZhengShuCode = (userId,zhengShuCode) => qspost('/Admin/User/setUserZhengShuCode', {userId,zhengShuCode})

/*
 * 会员管理-会员详情
 * @constructor jack
 * */
export const memberDetail = (user_id) => qspost('/Admin/User/getDetail', {user_id})


/*
 * 会员管理-审核列表
 * @constructor jack
 * */
export const checkList = (page,limit,name,rank_id,select_fenhui_id) => qspost('/Admin/User/getCheckList', {page,limit,name,rank_id,select_fenhui_id})


/*
 * 会员管理-审核列表
 * @constructor jack
 * */
export const getCheckFHUserList = (page,limit,name) => qspost('/Admin/User/getCheckFHUserList', {page,limit,name})


/*
 * 会员管理-会员审核详情
 * @constructor jack
 * */
export const getApplyUserData = (id) => qspost('/Admin/User/getApplyUserData', {id})

/*
 * 会员管理-会员审核详情修改
 * @constructor jack
 * */
export const memberApplyEdit = (userMoreJson,id,endTime,zhengShuCode) => qspost('/Admin/User/setApplyUser', {userMoreJson,id,endTime,zhengShuCode})

/*
 * 会员管理-会员审核通过/拒绝
 * @constructor jack
 * */
export const memberCheck = (id,status,examineMsg,endTime,zhengShuCode) => qspost('/Admin/User/setCheck', {id,status,examineMsg,endTime,zhengShuCode})




/*会员设置*/
/*
 * 级别管理-列表
 * @constructor jack
 * */
export const getRankList = (type = 1,user_type) => qspost('/Admin/User/getRankList', {type,user_type})
/*
 * 级别管理-列表
 * @constructor jack
 * */
export const getRankListByUserId = (id ) => qspost('/Admin/User/getRankList', {id})
/*
 * 级别管理-添加
 * @constructor jack
 * */
export const setRank = (type,name, price,user_type, id = '') => qspost('/Admin/User/setRank', {type,name, price,user_type, id})
/*
 * 级别管理-删除
 * @constructor jack
 * */
export const delRank = (id) => qspost('/Admin/User/delRank', {id})


/*
 * 标签管理-自定义标签列表
 * @constructor jack
 * */
export const customList = () => qspost('/Admin/Customlable/getRankList', {})

/*
 * 标签管理-内置标签详情
 * @constructor jack
 * */
export const labelDetail = (rankId,type= 1) => qspost('/Admin/User/getRankUserList', {rankId,type})

export const getUserFixedLableByFixedId = (fixedId) => qspost('/Admin/Customlable/getUserFixedLableByFixedId', {fixedId})




/*
 * 标签管理-自定义标签详情
 * @constructor jack
 * */
export const customDetail = (lableId) => qspost('/Admin/Customlable/getRankUserList', {lableId})

/*
 * 标签管理-自定义标签编辑
 * @constructor jack
 * */
export const customEdit = (name,userId,id) => qspost('/Admin/Customlable/addAndUpdateCustomLable', {name,userId,id})

/*
 * 标签管理-自定义标签删除
 * @constructor jack
 * */
export const customDel = (id) => qspost('/Admin/Customlable/delCustomLable', {id})


/*
* 信息管理-自定义表单获取
*
* */
export const getInformation = (fenhuiId = '') => qspost('/Admin/user/getUserMoreJson', {fenhuiId})

/*
* 信息管理-自定义表单获取
*
* */
export const getPersonalInformation = (fenhuiId = '') => qspost('/Admin/Personal/getUserMoreJson', {fenhuiId})

/*
* 信息管理-自定义表单提交
*
* */
export const saveInformation = (userMoreJson) => qspost('/Admin/user/addAndEditUserMoreJson', {userMoreJson})

/*
* 信息管理-自定义表单提交
*
* */
export const savePersonalInformation = (userMoreJson) => qspost('/Admin/Personal/addAndEditUserMoreJson', {userMoreJson})

/*会员说明*/

/*
 * 会员说明-详情
 * @constructor jack
 * */
export const explainDetail = (type) => qspost('/Admin/Article/getInfo', {type})

/*
 * 会员说明-提交
 * @constructor jack
 * */
export const explainEdit = (type,content) => qspost('/Admin/Article/edit', {type,content})

/*
 * 证书管理-证书展示
 * @constructor jack
 * */
export const certificateShow = (userType) => qspost('/Admin/zhengshu/getZhengShuBase', {userType})
/*
 * 证书管理-证书展示
 * @constructor jack
 * */
export const getPinShuBase = () => qspost('/Admin/zhengshu/getPinShuBase', {})

/*
 * 证书管理-证书上传
 * @constructor jack
 * */
export const certificateUp = () => qspost('/Admin/zhengshu/getZhengShuBase', {})

/*
 * 证书管理-证书保存
 * @constructor jack
 * */
export const certificateSave = (type,fileUrl,userType) => qspost('/Admin/zhengshu/saveZhengShuBase', {type,fileUrl,userType})


/*
 * 证书管理-证书保存
 * @constructor jack
 * */
export const savePinShuBase = (type,fileUrl) => qspost('/Admin/zhengshu/savePinShuBase', {type,fileUrl})




/*
 * 常见问题列表
  * * @constructor jack
 * */
export const getQuestionList = (page, limit, keyword) => qspost('Admin/Commonproblem/getList', {page, limit, keyword})

/*
 * 添加/修改常见问题
  * * @constructor jack
 * */
export const addQuestion = (id, title, content,key_word) => qspost('Admin/Commonproblem/setInfo', {id, title, content,key_word})


/*
 * 删除常见问题
  * * @constructor jack
 * */
export const delQuestion = (id) => qspost('Admin/Commonproblem/del', {id})

/*
 * 客服列表
  * * @constructor jack
 * */
export const getKefuList = () => qspost('Admin/Index/getKefuList', {})

/*
 * 删除客服
  * * @constructor jack
 * */
export const delKefu = (id) => qspost('Admin/Index/delKefu', {id})

/*
 * 添加客服
  * * @constructor jack
 * */
export const addKefu = (id,name,phone) => qspost('Admin/Index/setKefu', {id,name,phone})


/*
 * 意见反馈列表
  * * @constructor jack
 * */
export const getMessageList = (page, limit) => qspost('Admin/Message/getList', {page, limit})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const replyMessage = (id,content) => qspost('Admin/Message/remark', {id,content})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const delMessage = (id) => qspost('Admin/Message/del', {id})


/*
 * 组织信息
  * * @constructor jack
 * */
export const getParentInfo = () => qspost('Admin/Index/getParentInfo', {})

/*
 * 组织信息
  * * @constructor jack
 * */
export const setParentInfo = (morglogo,morgname,contacts,morgtel,address,morgemail
                              ,morgurl,morgdesc) => qspost('Admin/Index/setParentInfo', {
    morglogo,morgname,contacts,morgtel,address,morgemail,morgurl,morgdesc
})

/*
 * 组织动态-列表
 * @constructor jack
 * */
export const getActiveExamineList = (page, limit,state, keyword) => qspost('/admin/Noticeactive/getExamineList', {page, limit,state, keyword})
/*
 * 组织动态-列表 审核
 * @constructor jack
 * */
export const examineActiveData = (id, stateMsg,state) => qspost('/admin/Noticeactive/examineNoticeactiveData', {id, stateMsg,state})


/*
 * 组织动态列表
  * * @constructor jack
 * */
export const getActiveList = (page, limit, keyword) => qspost('admin/Noticeactive/query', {page, limit, keyword})


/*
 * 删除动态
  * * @constructor jack
 * */
export const delActive = (ids) => qspost('admin/Noticeactive/del', {ids})

/*
 * 添加动态
  * * @constructor jack
 * */
export const addActive = (title,content,images) => qspost('admin/Noticeactive/add', {
    title,content,images
})

/*
 * 编辑动态
  * * @constructor jack
 * */
export const editActive = (id,title,content,images) => qspost('admin/Noticeactive/edit', {
    id,title,content,images
})

/*
 * 动态
  * * @constructor jack
 * */
export const getActiveDetail = (id) => qspost('admin/Noticeactive/detail', {id})


/*
 * 机构活动
  * * @constructor jack
 * */
export const getMeetings = (status,type,page,limit) => qspost('Admin/Meeting/getList', {status,type,page,limit})

/*
 * 服务列表
  * * @constructor jack
 * */
export const getServerList = () => qspost('Admin/Server/getTypeList', {})

/*
 * 编辑提交数据
  * * @constructor jack
 * */
export const editServer = (id,title,desc,label,son_title,son_content,son_id) => qspost('Admin/Server/edit', {id,title,desc,label,son_title,son_content,son_id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerDetail = (id) => qspost('Admin/Server/detail', {id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerProjectList = (sid,rankId,searchName) => qspost('Admin/server/getAppointApplyBySid', {sid,rankId,searchName})

/*
 * 删除服务列表
  * * @constructor jack
 * */
export const delServer = (id) => qspost('Admin/Server/del', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delApply = (id) => qspost('Admin/Server/delApply', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delAllApply = (serverId) => qspost('Admin/Server/delApplyAll', {serverId})

/*
 * 处理记录
  * * @constructor jack
 * */
export const changeServerApply = (id,server_title,server_content,server_num
) => qspost('Admin/Server/changeServerApply', {id,server_title,server_content,server_num})

/*
 * 会员服务排序
  * * @constructor jack
 * */
export const sortServer = (id,sort) => qspost('Admin/Server/setSort', {id,sort})

/*
 * 支付列表
  * * @constructor jack
 * */
export const getOrderList = (search,page,limit) => qspost('admin/order/query', {search,page,limit})


/*
 * 支付列表
  * * @constructor jack
 * */
export const getFhOrderList = (search,page,limit) => qspost('admin/order/getExamineList', {search,page,limit})


/*
 * 支付状态
  * * @constructor jack
 * */
export const setIsPayState = (order_number,is_pay) => qspost('admin/order/setIsPayState', {order_number,is_pay})


/*
 * 开票状态
  * * @constructor jack
 * */
export const setInvoiceState = (order_number,fapiao_img,invoice_state) => qspost('admin/order/setInvoiceState', {order_number,fapiao_img,invoice_state})

/*
 * 开票状态
  * * @constructor jack
 * */
export const setInvoiceStateFH = (order_number,fapiao_img,invoice_state) => qspost('admin/order/setInvoiceStateFH', {order_number,fapiao_img,invoice_state})


/*
 * 发票管理列表
  * * @constructor jack
 * */
export const getInvoiceList = (search,start_time,end_time,page,limit) => qspost('Admin/User/getInvoiceList', {search,start_time,end_time,page,limit})

/*
 * 发票管理列表
  * * @constructor jack
 * */
export const getInvoiceFHList = (search,start_time,end_time,page,limit) => qspost('Admin/User/getInvoiceFHList', {search,start_time,end_time,page,limit})


/*
 * 微信商户信息
  * * @constructor jack
 * */
export const getWxPayInfo = () => qspost('admin/wechat/wechatConfig_index', {})

/*
 * 设置微信商户信息
  * * @constructor jack
 * */
export const setWxPayInfo = (wx_appid,wx_mch_id,wx_apikey,wx_appsecret,is_h5) => qspost('admin/wechat/wechatConfig_update', {wx_appid,wx_mch_id,wx_apikey,wx_appsecret,is_h5})


/*
 * 对公转账信息
  * * @constructor jack
 * */
export const getDuiGongData = () => qspost('admin/User/getDuiGongData', {})


/*
 * 设置对公转账
  * * @constructor jack
 * */
export const setDuiGongData = (kaiHuHang,kaHao,shouKuanDanWei,fapiao_img,pay_img) => qspost('admin/User/setDuiGongData', {kaiHuHang,kaHao,shouKuanDanWei,fapiao_img,pay_img})


/*
 *  缴费信息列表
 * @constructor jack
 * */

export const getPayLog = (user_id) => qspost('admin/User/getPayLog', {user_id})


/*
****分支机构*****
*  **/

/*
 *  分支机构列表
 * @constructor jack
 * */

export const listOrgFenHui = (rankId,searchName,page,limit) => qspost('Admin/User/listOrgFenHui', {rankId,searchName,page,limit})

/*
 *  分支机构列表
 * @constructor jack
 * */

export const getCheckListFh = (rankId,searchName,page,limit) => qspost('Admin/User/getCheckListFh', {rankId,searchName,page,limit})

/*
 * 创建分支机构

  * * @constructor jack
 * */
export const createOrgFenHui = (id,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc,pinShuCode) => qspost('Admin/User/createOrgFenHui', {
    id,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc,pinShuCode
})

/*
 * 分支机构详情
  * * @constructor jack
 * */
export const showOrgFenHui = (id) => qspost('Admin/User/showOrgFenHui', {
    id
})

/*
 * 删除分支机构
  * * @constructor jack
 * */
export const delOrgFenHui = (id) => qspost('Admin/User/delOrgFenHui', {
    id
})

/*
 * 会员管理-会员审核详情修改
 * @constructor jack
 * */
export const setApplyUserFh = (id,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc,pinShuCode) => qspost('/Admin/User/setApplyUserFh', {id,logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc,pinShuCode})

/*
 * 分支机构管理-分支机构审核通过/拒绝
 * @constructor jack
 * */
export const fhCheck = (id,status,examineMsg) => qspost('/Admin/User/setCheckFh', {id,status,examineMsg})

/*
 * 分支机构管理-会员审核详情
 * @constructor jack
 * */
export const getApplyUserDataFh = (id) => qspost('/Admin/User/getApplyUserDataFh', {id})

/*
 *  获取 会员说明 - 机构
 * @constructor jack
 * */
export const getMemberClassifyList = () => qspost('/admin/Article/getList', {})

/*
 * 添加/修改 文章分类 - 机构
 * @constructor jack
 * */
export const createAndUpdateArticleType = (id,name) => qspost('/admin/Article/createAndUpdateArticleType', {id,name})

/*
 *  删除 文章分类 - 机构
 * @constructor jack
 * */
export const delArticleType = (id) => qspost('/admin/Article/delArticleType', {id})

/*
 *  删除 文章 - 机构
 * @constructor jack
 * */
export const delArticle = (id) => qspost('/admin/Article/delArticle', {id})

/*
 * 添加 文章 - 机构
 * @constructor jack
 * */
export const editArticle = (id,type,title,content) => qspost('/admin/Article/edit', {id,type,title,content})

/*
 * 文章详情  -
 * @constructor jack
 * */
export const getInfoArticle = (id) => qspost('/admin/Article/getInfo', {id})


/*
 * 添加 文章 - 机构
 * @constructor jack
 * */
export const saveBasesArticleData = (oid,fid,type,title,content) => qspost('/admin/Article/saveBasesArticleData', {oid,fid,type,title,content})

/*
 * 文章详情  -
 * @constructor jack
 * */
export const getBasesArticleData = (oid,fid,type) => qspost('/admin/Article/getBasesArticleData', {oid,fid,type})




/*
 * 子管理权限设置
 * @constructor jack
 * */
export const setSonPower = (id,powerStr) => qspost('/admin/user/setSonPower', {id,powerStr})

/*
 * 子管理权限获取
 * @constructor jack
 * */
export const getSonPower = (id) => qspost('/admin/user/getSonPower', {id})



/*
 * 分支机构权限设置
 * @constructor jack
 * */
export const setFhPower = (id,powerStr) => qspost('/admin/user/setFhPower', {id,powerStr})

/*
 * 分支机构权限获取
 * @constructor jack
 * */
export const getFhPower = (id) => qspost('/admin/user/getFhPower', {id})
/*
 * 审核数量统计
 * */
export const orgCheckFhDataNumber = () => qspost('/admin/tongji/orgCheckFhDataNumber', {})

/*
 * 添加缴费记录
 * */
export const setUserEndTime = (userId,startTime,endTime,payAmount,remark) => qspost('/Admin/User/setUserEndTime', {userId,startTime,endTime,payAmount,remark})

/*
 * 删除缴费记录
 * */
export const delUserPayLogData = (id) => qspost('/Admin/User/delUserPayLogData', {id})

/*
 * 自定义统计的json信息
 * */
export const customFieldStatistics = (id) => qspost('/admin/Tongji/customFieldStatistics', {id})

/*
 * tongJiUserNumberByTime
 * */
export const tongJiUserNumberByTime = (starttime,endtime) => qspost('/Admin/tongji/tongJiUserNumberByTime', {starttime,endtime})

/*
 * tongJiUserFeeByTime
 * */
export const tongJiUserFeeByTime = (starttime,endtime) => qspost('/Admin/tongji/tongJiUserFeeByTime', {starttime,endtime})

/*
 *  修改密码 - 只有总会有此功能
 * */
export const updatePassword = (phone,oldPass,newPass,newRPass) => qspost('/admin/User/updatePassword', {phone,oldPass,newPass,newRPass})

/*
 *  总会 - 获得自己的机构子管理 - 总会
 * */
export const getSonAdmin = (searchName) => qspost('/admin/User/getSonAdmin', {searchName})

/*
 *  总会 - 添加自己的机构子管理 - 总会
 * */
export const addSonAdmin = (id,name,account,password,power = '') => qspost('/admin/User/addSonAdmin', {id,name,account,password,power})

/*
 *  总会 - 删除自己的机构子管理 - 总会
 * */
export const delSonAdmin = (id) => qspost('/admin/User/delSonAdmin', {id})

/*
 *  用户证书信息详情
 * */
export const getUserCertDetail = (user_id) => qspost('/admin/user_cert/detail', {user_id})

/*
 *  用户证书信息更新信息
 * */
export const upUserCertDetail = (user_id,cert_name, cert_content, cert_code, cert_company,
                                 cert_date,cert_time_start,cert_time_end) => qspost('/admin/user_cert/update', {user_id,cert_name, cert_content, cert_code, cert_company, cert_date,cert_time_start,cert_time_end})




/*
 *  用户证书信息详情
 * */
export const getPinShuDetail = (id) => qspost('/admin/user_cert/detail_pinshu', {id})

/*
 *  用户证书信息更新信息
 * */
export const upPinShuDetail = (id,pinshu_name, pinshu_content, pinshu_code, pinshu_company,
                               pinshu_date) => qspost('/admin/user_cert/update_pinshu', {id,pinshu_name, pinshu_content, pinshu_code, pinshu_company,
    pinshu_date})

/*
 *  管理端查询网站基础设置
 * */
export const getWebSetInfo = () => qspost('/admin/Webset/getWebSetInfo', {})

/*
 *  管理端编辑网站基础设置
 * */
export const setWebSet = (showGerenRegister,showOrgRegister, registerPay,smsNotice,userTypeSort
) => qspost('/admin/Webset/setWebSet', {showGerenRegister,showOrgRegister, registerPay,smsNotice,userTypeSort})

/*
 *  短信套餐
 * */
export const getSMSSetMeal = () => qspost('/admin/Sendsms/getSMSSetMeal', {})

/*
 *  检查订单状态
 * */
export const checkSMSOrder = (orderNumber) => qspost('/admin/Sendsms/checkSMSOrder', {orderNumber})

/*
 *  购买短信套餐
 * */
export const createSMSOrder = (type) => qspost('/admin/Sendsms/createSMSOrder', {type})

/*
 *  积分配置接口
 *
 * */
export const setIntegral = (login_num,user_renewal,to_activity,sign_activity,
                            show_iterative,back_iterative,show_org,apply_service ) => qspost('/Admin/Integral/setIntegral', {
    login_num,user_renewal,to_activity,sign_activity,
    show_iterative,back_iterative,show_org,apply_service
})

/*
 *  积分配置详情
 *
 * */
export const getConfigurationDetail = (oid) => qspost('/Admin/Integral/configurationDetail', {
    oid
})

/*
 *  绑定微信
 *
 * */
export const bindWx = (phone,code) => qspost('/home/user/bindWx', {
    phone,code
})

/*
 *  解绑微信
 *
 * */
export const unBindWx = (phone) => qspost('home/user/unbound', {
    phone
})






//---------------------------------------改版统计


/*
 *  会员统计
 * */
export const getUserTotal = () => qspost('Admin/Statistics/tongJiUserNumberNew', {})

/*
 *  职务统计
 * */
export const getJobTotal = () => qspost('Admin/Statistics/tongJiUserJobNumber', {})

/*
 *  费用统计
 * */
export const getCostTotal = () => qspost('Admin/Statistics/tongJiUserCostNumber', {})

/*
 *  受益、服务人数
 * */
export const getServiceNumberTotal = () => qspost('Admin/Statistics/benefitPeopleNum', {})

/*
 *  暖心服务
 * */
export const getServiceListTotal = () => qspost('Admin/Statistics/nuanxinService', {})
/*
 *  根据type获取短信模板
 * */
export const getMobanByType = (type) => qspost('Admin/Statistics/getMobanByType', {type})

/*
 *  暖心服务列表
 * */
export const getServiceList= (type,rank_id,select_fenhui_id,keyword) => qspost('Admin/Statistics/nuanxinServicelist', {type,rank_id,select_fenhui_id,keyword})

/*
 *  待办提醒
 * */
export const getRemindListTotal = () => qspost('Admin/Statistics/agencyRemind', {})

/*
 *  会员贡献top10
 * */
export const getRankListTotal = () => qspost('Admin/Statistics/memberContribution', {})

/****************************************自动发送短信**************************************/


/*
 *  验证是否存在发送的字段
 * */
export const checkAutoSendfield = (name) => qspost('admin/Sendsms/checkAutoSendfield', {name})


/*
 *  设置自动发送状态
 * 0关 1开
 * */
export const setAutoSendState = (name,state) => qspost('admin/Sendsms/setAutoSendState', {name,state})


/*
 *  获取自动发送状态
 * */
export const getAutoSendState = () => qspost('admin/Sendsms/getAutoSendState', {})


/*
 *  自动短信发送记录
 * 1用户 2 管理员
 * */

export const getAutoSendSmsLog = (type,page,limit) => qspost('admin/Sendsms/getAutoSendSmsLog', {type,page,limit})


/*
 *  获取下载模版状态
 * */

export const getDownTempState = (type) => qspost('admin/Usertool/getDownloadTplAlert', {type})


/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUser_optimized = (op_type,file_path,page,limit) => qspost('Admin/User/importUser_optimized', {op_type,file_path,page,limit})

/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUpdateUser_optimized = (op_type,file_path,page,limit) => qspost('Admin/User/importUpdateUser_optimized', {op_type,file_path,page,limit})


/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importPersonalUser_optimized = (op_type,file_path,page,limit) => qspost('Admin/Personal/importUser_optimized', {op_type,file_path,page,limit})

/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUpdatePersonalUser_optimized = (op_type,file_path,page,limit) => qspost('Admin/Personal/importUpdateUser_optimized', {op_type,file_path,page,limit})

/*
 *  获取会员类型描述
 * */
export const getUserTypeDesc = (user_type) => qspost('Admin/Usertypedesc/getUserTypeDesc', {user_type})

/*
 *  获取会员类型描述
 * */
export const setUserTypeDesc = (id,is_show,content,spe_content) => qspost('Admin/Usertypedesc/setUserTypeDesc', {id,is_show,content,spe_content})

/*
 * 意见反馈
 * */
export const feedback = (phone,content,source = 1) => qspost(ONLINEHOST_EMOF + 'home/index/feedback', {
    phone,content,source
})
